import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, FileUploadFor, KeyValues5, LanguageKeyType, LocalService, PageKey, Status, TriggeredEvent } from '../../../service/local.service';
import { LanguageComponent } from '../../popups/language/language.component';
import { LanguageSelectionComponent } from 'src/app/popups/language-selection/language-selection.component';
import { MessageComponent } from 'src/app/popups/message/message.component';

@Component({
  selector: 'app-language-config',
  templateUrl: './language-config.component.html',
  styleUrls: ['./language-config.component.scss']
})
export class LanguageConfigComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  lstSectionConfigKeys: string[] = ["table"];
  wrappers: KeyValues5[]; isAutoRefreshEnabled = false;
  
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.ensurePageActions(PageKey.Languages);
    this.loadLanguages();
  }

  loadLanguages() {
    this.languageManagementService.getLanguages().subscribe(result => {
      this.wrappers = result;
    });
  }

  loadLanguagesRefresh() {
    if (this.wrappers.filter(x => x.v4 == '100.00').length > 0) {
      this.languageManagementService.getLanguages(false).subscribe(result => {
        this.wrappers.forEach(item => {
          let itemTemp = result.find(x => x.key == item.key);
          if (itemTemp.v4 != item.v4) {
            item.v4 = itemTemp.v4;
          }
        });
      });
    }
  }

  openLanguage(id: string) {
    const modalRef = this.modalService.open(LanguageComponent, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    modalRef.componentInstance.id = id;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        if (id == '') {
          this.wrappers.push(result.wrapper);
        }
        else {
          const temp = this.wrappers.find(x => x.key == result.wrapper.id);
          temp.v1 = result.wrapper.content.code;
          temp.v2 = result.wrapper.content.title;
        }
      }
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.languageManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Language).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == strId);
        updatedItem.v3 = updatedItem.v3 == "1" ? "0" : "1";
      }
    });
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        this.languageManagementService.getWords(key, true).subscribe(result => {
          this.localService.onDownloadFile(result, 'MissedWords');
        });
      } break;
      case 2: {
        this.languageManagementService.getWords(key, false).subscribe(result => {
          const temp = this.wrappers.find(x => x.key == key);
          this.localService.onDownloadFile(result, 'AllWords_' + temp.v1);
        });
      } break;
      case 3: {
        this.languageManagementService.getWords('', false).subscribe(result => {
          this.localService.onDownloadFile(result, 'AllWords');
        });
      } break;
      case 4: {
        if (key) {
          this.languageManagementService.updateAutoTranslationBulk(LanguageKeyType.None, undefined, undefined, undefined, key).subscribe(result => {
            this.localService.showInformationByStatus(result);
          });
        } else {
          const modalRef = this.modalService.open(LanguageSelectionComponent);
          modalRef.componentInstance.isInnerUsage = true;
          modalRef.componentInstance.isShowAll = true;
          modalRef.result.then((result) => {
            if (result.event == TriggeredEvent.Ok) {
              let languageId = result.data;
              this.languageManagementService.updateAutoTranslationBulk(LanguageKeyType.None, undefined, undefined, undefined, languageId).subscribe(result => {
                this.localService.showInformationByStatus(result);
              });
            }
          });
        }
      } break;
      case 5: {
        this.languageManagementService.refreshSearchValue(LanguageKeyType.LanguageEquivalentTitle).subscribe(result => {
          this.localService.showInformationByStatus(result);
        });
      } break;
      case 6: {
        const modalRef = this.modalService.open(MessageComponent);
        modalRef.componentInstance.IsConfirmationType = true;
        modalRef.componentInstance.message = this.localService.languageContent.common.delete_confirmation;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.languageManagementService.deleteLanguage(key).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
              this.loadLanguages();
            });
          }
        });
      } break;
    }
  }
}
